import { CommonModule, ViewportScroller } from '@angular/common';
import { AfterViewInit, Component, ViewEncapsulation } from '@angular/core';
import {
    FormControl,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { SelectHomeComponent } from 'app/components/select-home/select-home.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { AnnouncementsComponent } from './announcements/announcements.component';
import { CustomerSaysComponent } from './customer-says/customer-says.component';
import { NewsComponent } from './news/news.component';
import { SupportedBanksComponent } from './supported-banks/supported-banks.component';
import { LoanCalculatorComponent } from './loan-calculator/loan-calculator.component';
import { TranslateModule } from '@ngx-translate/core';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { SubmitYoursComponent } from './submit-yours/submit-yours.component';
import { HomePageService } from './home.service';
import { ApplicationService } from 'app/services/application.service';
import { CustomerTestimony, Partner } from './home.types';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { FaqComponent } from './faq/faq.component';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { environment } from 'environments/environment';
import { HomeBenefitsComponent } from './components/home-benefits/home-benefits.component';
import { HomeServicesComponent } from './components/home-services/home-services.component';
import { HomeFeaturesComponent } from './components/home-features/home-features.component';
import { HomeWhatsNewComponent } from './components/home-whats-new/home-whats-new.component';
import { catchError, forkJoin, of } from 'rxjs';
import sal from 'sal.js';
import { ToastrService } from 'ngx-toastr';
import { formatUrlEncode, htmlToString } from 'app/shared/utils';

@Component({
    selector: 'landing-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        HeaderComponent,
        SlickCarouselModule,
        CommonModule,
        RouterModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        FooterComponent,
        MatDialogModule,
        MatButtonModule,
        SelectHomeComponent,
        NewsComponent,
        SupportedBanksComponent,
        CustomerSaysComponent,
        TranslateModule,
        ContactUsComponent,
        FaqComponent,
        HomeBenefitsComponent,
        HomeServicesComponent,
        HomeFeaturesComponent,
        HomeWhatsNewComponent,
    ],
    standalone: true,
})
export class LandingHomeComponent implements AfterViewInit {
    arrBM: any = [];
    arrEN: any = [];
    bannersBM: any = [];
    bannersEN: any = [];
    bannerData: any = [];
    arrBannerBM: any = [];
    arrBannerEN: any = [];
    arrWhatsNewBM: any = [];
    arrWhatsNewEN: any = [];
    whatsNewData: any = [];
    whatsNewBM: any = [];
    whatsNewEN: any = [];
    EXTERNAL = 'External';

    testimonies: CustomerTestimony[] = [];
    partnerDetails: Partner[] = [];
    homepageDetails: any = [];
    newsDetails: any;
    currentSlide: number = 0;

    calculatorIsOpen: boolean = false;
    languageSelected: any;
    isAuthenticated: boolean = false;

    emailFormControl = new FormControl('', [
        Validators.required,
        Validators.email,
    ]);

    selectedRepaymentYearsValue: null | string = '10';
    selectedInterestValue: null | string = '5';

    slideConfig = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow:
            '<button class="slick-prev"><img src="/assets/images/icons/arrow-left.svg" alt="Previous" /></button>',
        nextArrow:
            '<button class="slick-next"><img src="/assets/images/icons/arrow-right.svg" alt="Next" /></button>',
    };

    selectOptionYears = [
        {
            value: '10',
            label: '10 Years',
        },
        {
            value: '5',
            label: '5 Years',
        },
        {
            value: '2',
            label: '2 Years',
        },
        {
            value: '1',
            label: '1 Years',
        },
    ];

    selectOptionsInterest = [
        {
            value: '5',
            label: '5%',
        },
        {
            value: '10',
            label: '10%',
        },
        {
            value: '15',
            label: '15%',
        },
        {
            value: '20',
            label: '20%',
        },
    ];

    clickedOutside: boolean = false;

    enableDraft = environment.dev;

    constructor(
        public dialog: MatDialog,
        private homepageService: HomePageService,
        private router: Router,
        private route: ActivatedRoute,
        private viewportScroller: ViewportScroller,
        private _applicationService: ApplicationService,
        private toastr: ToastrService,
    ) {
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true';
    }

    ngAfterViewInit(): void {
        if (sal) {
            sal();
        }
    }

    handleSelectionChangeRepaymentYears(value: string) {
        this.selectedRepaymentYearsValue = value;
    }

    handleSelectionChangeInterest(value: string) {
        this.selectedInterestValue = value;
    }

    afterChange(e) {
        this.currentSlide = e.currentSlide;
    }

    beforeChange(e) {
        this.currentSlide = e.currentSlide;
    }

    toggleCalculatorOpen() {
        if (!this.calculatorIsOpen) {
            this.openCalculator();
        } else {
            this.closeCalculator();
        }
    }

    openCalculator() {
        this.calculatorIsOpen = true;
        this.dialog.open(LoanCalculatorComponent, {
            hasBackdrop: true,
            backdropClass: 'loan-calculator-dialog-background',
            panelClass: 'loan-calculator-custom-dialog',
            maxWidth: 700,
        });
    }

    closeCalculator() {
        this.dialog.closeAll();
        this.calculatorIsOpen = false;
    }

    ngOnInit() {
        this.homepageService.getHomepageDetails().subscribe((data) => {
            this.homepageDetails = { ...data };
        });

        this.homepageService.getPartnerDetails().subscribe((data: any) => {
            this.partnerDetails = [...data];
        });

        this.languageSelected = localStorage.getItem('language');

        if (this.enableDraft) {
            this.homepageService.getNewsHome().subscribe((data) => {
                this.newsDetails = data;
            });
        }

        this.checkFromMitiPages();

        this.getCampaignsList(); // get Campaigns

        this.route.fragment.subscribe((fragment) => {
            if (fragment) {
                this.viewportScroller.scrollToAnchor(fragment);
            }
        });
    }

    openAnnouncementsDialog() {
        this.dialog.open(AnnouncementsComponent, {
            backdropClass: 'announcement-dialog-background',
            hasBackdrop: true,
            panelClass: 'announcement-custom-dialog',
        });
    }

    openSubmitYours() {
        this.dialog.open(SubmitYoursComponent, {
            panelClass: 'submit-yours-dialog',
            scrollStrategy: new NoopScrollStrategy(),
        });
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    getCampaignsList(): void {
        const now = new Date().getTime();
        const today = new Date().setHours(0, 0, 0, 0);

        const banner = this._applicationService.getCampaign('HOMEPAGE').pipe(
            catchError(() => of([]))
        );
        const whatsNew =
            this._applicationService.getCampaign('WHATSNEW-CAMPAIGN').pipe(
                catchError(() => of([]))
            );
        const whatsNewNews =
            this._applicationService.getCampaign('WHATSNEW-NEWS').pipe(
                catchError(() => of([]))
            );
        const whatsNewInsights =
            this._applicationService.getCampaign('WHATSNEW-INSIGHTS').pipe(
                catchError(() => of([]))
            );

        forkJoin([banner, whatsNew, whatsNewNews, whatsNewInsights]).subscribe({
            next: ([
                bannerData,
                whatsNewData,
                whatsNewNewsData,
                whatsNewInsightsData,
            ]) => {
                // Filter BANNER campaigns
                const filteredBanner = bannerData.filter((item) => {
                    if (item?.bannerStartDate && item?.bannerEndDate) {
                        const start = new Date(item.bannerStartDate).getTime();
                        const end = new Date(item.bannerEndDate).getTime();
                        return start <= now && end >= now;
                    }
                    return false;
                });

                // Filter Whatsnew campaigns
                const filteredWhatsNewCampaign = whatsNewData.filter((item) => {
                    if (item?.campaignStartDate && item?.campaignEndDate) {
                        const start = new Date(item.campaignStartDate).setHours(
                            0,
                            0,
                            0,
                            0,
                        );
                        const end = new Date(item.campaignEndDate).setHours(
                            0,
                            0,
                            0,
                            0,
                        );
                        return start <= today && end >= today;
                    }
                    return false;
                });

                // combine campaigns + news + insights
                const combinedWhatsNew = [
                    ...(filteredWhatsNewCampaign ?? []),
                    ...(whatsNewNewsData ?? []).map((item) => ({
                        ...item,
                        _category: 'WHATSNEW-NEWS',
                    })),
                    ...(whatsNewInsightsData ?? []),
                ];
                const filteredWhatsNew = combinedWhatsNew;

                // Process languages: Whats new
                this.arrWhatsNewBM = [];
                this.arrWhatsNewEN = [];
                filteredWhatsNew.forEach((el: any) => {
                    this.processWhatsNewLanguages(
                        el,
                        this.arrWhatsNewBM,
                        this.arrWhatsNewEN,
                    );
                });
                // Limit to 6 banners max
                this.whatsNewBM = this.arrWhatsNewBM.slice(0, 6);
                this.whatsNewEN = this.arrWhatsNewEN.slice(0, 6);
                this.whatsNewData =
                    this.languageSelected === 'bm'
                        ? this.whatsNewBM
                        : this.whatsNewEN;

                // Process languages: Banner
                this.arrBannerBM = [];
                this.arrBannerEN = [];
                filteredBanner.forEach((el: any) => {
                    this.processBannerLanguages(
                        el,
                        this.arrBannerBM,
                        this.arrBannerEN,
                    );
                });

                this.arrBannerBM = this.arrBannerBM.filter(
                    (e) => e?.campaigndetails?.isBannerRequired === 'Yes',
                );
                this.arrBannerEN = this.arrBannerEN.filter(
                    (e) => e?.campaigndetails?.isBannerRequired === 'Yes',
                );

                // Limit to 20 banners max
                this.bannersBM = this.arrBannerBM.slice(0, 20);
                this.bannersEN = this.arrBannerEN.slice(0, 20);

                this.bannerData =
                    this.languageSelected === 'bm'
                        ? this.bannersBM
                        : this.bannersEN;
            },
            error: (err) => {
                console.log('Error: ', err);
            },
        });
    }

    processWhatsNewLanguages(item: any, bmArray: any[], enArray: any[]) {
        let newObj;
        const details = item?.campaigndetails || [];
        for (let detail of details) {
            newObj = { ...item, campaigndetails: detail };
            if (detail?.languages === 'BM') {
                bmArray.push(newObj);
            } else if (detail?.languages === 'EN') {
                enArray.push(newObj);
            }
        }
    }

    processBannerLanguages(item: any, bmArray: any[], enArray: any[]) {
        let newObj;
        const details = item?.campaigndetails || [];
        for (let detail of details) {
            newObj = {
                ...item,
                campaignUrl: detail?.campaignUrl,
                campaignDetUrl: detail?.campaignDetUrl,
                campaigndetails: detail,
            };
            if (detail?.languages === 'BM') {
                bmArray.push(newObj);
            } else if (detail?.languages === 'EN') {
                enArray.push(newObj);
            }
        }
    }

    viewWhatsNewDetails(data) {
        let whitespace = new Set([' ', '\t', '\n']);
        if (data?._category === 'WHATSNEW-NEWS') {
            const url =
                '/in-the-news/' +
                data.id +
                '/' +
                formatUrlEncode(
                    htmlToString(data['campaigndetails'].campaignDescription),
                );
            this.router.navigateByUrl(url);
            return;
        }
        if (data?.campaigndetails?.isCampaignRequired == 'Yes') {
            let language = '?language=' + this.languageSelected;
            let url: any =
                '/campaign/' +
                data.id +
                '/' +
                formatUrlEncode(
                    htmlToString(data['campaigndetails'].campaignDescription),
                );
            //  + language;
            this.router.navigateByUrl(url);
        } else {
            if (data?.campaigndetails?.campaignUrl) {
                if (
                    (data?.campaigndetails?.campaignUrl ?? '').includes(
                        'https://',
                    ) ||
                    (data?.campaigndetails?.campaignUrl ?? '').includes(
                        'http://',
                    ) ||
                    (data?.campaigndetails?.campaignUrl ?? '').includes(
                        'www',
                    ) ||
                    (data?.campaigndetails?.campaignUrl ?? '').includes('/')
                ) {
                    if (data?.ctaType == this.EXTERNAL) {
                        window.open(
                            data?.campaigndetails?.campaignUrl,
                            '_blank',
                        );
                    } else {
                        window.open(
                            data?.campaigndetails?.campaignUrl,
                            '_self',
                        );
                    }
                } else {
                    for (
                        let i = 0;
                        i < data?.campaigndetails?.campaignUrl?.length;
                        i++
                    ) {
                        if (
                            whitespace.has(
                                data?.campaigndetails?.campaignUrl[i],
                            )
                        ) {
                            if (this.languageSelected == 'bm') {
                                this.toastr.error(
                                    'Oops. Terdapat ralat dalam sistem.',
                                );
                            } else {
                                this.toastr.error('Oops.Something went wrong.');
                            }
                        } else {
                            let productCode =
                                data?.campaigndetails?.campaignUrl;
                            if (this.isAuthenticated) {
                                this.router.navigate(['/business-financing'], {
                                    queryParams: {
                                        productCode: productCode,
                                    },
                                });
                            } else {
                                this.router.navigate(['/login'], {
                                    queryParams: {
                                        returnUrl: `/business-financing?productCode=${productCode}`,
                                    },
                                });
                            }
                        }
                    }
                }
            } else {
                if (this.languageSelected == 'bm') {
                    this.toastr.error('Oops. Terdapat ralat dalam sistem.');
                } else {
                    this.toastr.error('Oops.Something went wrong.');
                }
            }
        }
    }

    onClickImageRoute = (routePath: string) => {
        window.location.href = routePath;
    };

    getLocalStorageValue(item) {
        return localStorage.getItem(item);
    }

    switchLanguageHandler(data: any) {
        this.languageSelected = data;
        if (this.languageSelected == 'bm') {
            this.bannerData = this.bannersBM;
            this.whatsNewData = this.whatsNewBM;
        } else if (this.languageSelected == 'en') {
            this.bannerData = this.bannersEN;
            this.whatsNewData = this.whatsNewEN;
        }
    }

    checkFromMitiPages() {
        setTimeout((x) => {
            if (
                localStorage.getItem('miti-enq') ||
                localStorage.getItem('support-btn')
            ) {
                const element = document.getElementById('contactUs');
                if (element) {
                    const yOffset = -80;
                    const yPosition =
                        element.getBoundingClientRect().top +
                        window.scrollY +
                        yOffset;

                    window.scrollTo({
                        top: yPosition,
                        behavior: 'smooth',
                    });
                }
                localStorage.removeItem('miti-enq');
                localStorage.removeItem('support-btn');
            }
        }, 1000);
    }
}
